import { SHARED_NAMESPACE } from '@/store/shared'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'
import { openFileContentsInBrowser } from '@/utilities'

import { AddressesActions } from './partials/addresses'
import { DetectionActions } from './partials/detection'
import { EmailsActions } from './partials/emails'
import { LegalCasesActions } from './partials/legal-cases'
import { LinkablePartiesActions } from './partials/linkable-parties'
import { PartyEditActions } from './partials/party-edit'
import { PartyMergeActions } from './partials/party-merge'
import { PartySurveysPageActions } from './partials/party-surveys-page'
import { PartyTagActions } from './partials/party-tag'
import { PhonesActions } from './partials/phones'
import { ResidenceHistoriesActions } from './partials/residence-histories'

export const PartyActions = {
  ...AddressesActions,
  ...DetectionActions,
  ...EmailsActions,
  ...LegalCasesActions,
  ...LinkablePartiesActions,
  ...PartyEditActions,
  ...PartyMergeActions,
  ...PhonesActions,
  ...PartyTagActions,
  ...ResidenceHistoriesActions,
  ...PartySurveysPageActions,

  deletePartyCharacteristic ({ commit }, req) {
    return axiosRequest.
      delete(`/parties/${req.partyId}/${req.type}/${req.id}`).
      then(({ data }) => {
        commit(`set${req.typeName}`, data[req.type])
      }).
      catch(handleError)
  },
  fetchParties ({ dispatch }) {
    return dispatch(`${SHARED_NAMESPACE}/getDropdownOptions`, { options: false, path: 'parties' }, { root: true })
  },
  async getParties ({ commit }, partyIds, opts) {
    return axiosRequest.
      get('/parties', {
        params: {
          party_ids: partyIds,
          options: opts,
        },
      }).
      then(({ data }) => data).
      catch(handleError)
  },
  async getPartiesWithOptions ({ commit }, { partyIds, options }) {
    return axiosRequest.
      get('/parties', {
        params: {
          party_ids: partyIds,
          options: JSON.stringify(options),
        },
      }).
      then(({ data }) => data).
      catch(handleError)
  },
  async getPartyOptions ({ commit }) {
    return axiosRequest.
      get('/options/parties/party_id').
      then(({ data }) => {
        commit('setParties', data.options)
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },
  async getParty ({ commit }, partyId) {
    return axiosRequest.
      get(`/parties/${partyId}`).
      then(({ data }) => commit('setCurrentParty', data.party)).
      catch(handleError)
  },
  async getPartyPublicView (_, partyId) {
    return axiosRequest.
      get(`/parties/${partyId}/public`).
      then(({ data }) => (data)).
      catch(handleError)
  },

  async printPhoto (_, partyId) {
    return axiosRequest({
      method: 'get',
      responseType: 'blob',
      url: `/parties/${partyId}/photos/print`,
    }).
      then(response => {
        openFileContentsInBrowser(response.data, 'application/pdf', true, 'photo.pdf')
      })
  },
}
